import {
    DashboardOutlined as DashboardIcon,
    Inventory2Outlined as PackagesIcon,
    PeopleAltOutlined as PeopleIcon
} from '@mui/icons-material';
import { useAuthContext, useMenuContext } from 'contexts';
import { Dashboard, DashboardPacotes, Users, UsersDetalhe } from 'pages';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

export const AppRoutes = () => {
    const { handleOptionsMenu } = useMenuContext();
    const { isAdmin } = useAuthContext();

    useEffect(() => {
        const options = [
            {
                id: 1,
                icon: <DashboardIcon />,
                label: 'Vendas',
                path: '/dashboard'
            },
            {
                id: 2,
                icon: <PackagesIcon />,
                label: 'Pacotes',
                path: '/dashboard/pacotes'
            }
        ];

        if (isAdmin) {
            options.push({
                id: 3,
                icon: <PeopleIcon />,
                label: 'Usuários',
                path: '/users'
            });
        }

        handleOptionsMenu(options);
    }, [handleOptionsMenu, isAdmin]);

    return (
        <Routes>
            <Route
                path='/dashboard'
                element={<Dashboard />}
            />
            <Route
                path='/dashboard/pacotes'
                element={<DashboardPacotes />}
            />
            {isAdmin && (
                <>
                    <Route
                        path='/users'
                        element={<Users />}
                    />
                    <Route
                        path='/users/detalhe/:id'
                        element={<UsersDetalhe />}
                    />
                </>
            )}
            <Route
                path='*'
                element={<Navigate to='/dashboard' />}
            />
        </Routes>
    );
};
